import React, { useState } from "react";
import ImageManager from "components/molecures/ImageManager";
import { Button, Dialog, DialogActions } from "@material-ui/core";

import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

type Props = {
  onChange: any;
  value: any;
};
const UploadImage = (props: Props) => {
  const { value, onChange } = props;
  const [prevSrc, setPrevSrc] = useState(); //選択候補フォト
  const { t } = useTranslation();

  const [open, setOpen] = React.useState(false);

  const _setValue = (phot: any) => {
    onChange(phot.id);
    setPrevSrc(phot.src);
  };

  const resetValue = () => {
    onChange(null);
    setPrevSrc(null);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  React.useEffect(() => {
    if (value && typeof value === "object" && "url" in value) {
      setPrevSrc(value.url);
      onChange(value.id);
    }
  }, [value]);
  React.useEffect(() => {}, [prevSrc]);

  return (
    <>
      {prevSrc && (
        <>
          <Grid>
            <img src={prevSrc} style={{ maxWidth: 320 }}></img>
            <HighlightOffIcon onClick={resetValue} />
          </Grid>
        </>
      )}
      <Button
        variant="contained"
        color="primary"
        component="div"
        onClick={handleClickOpen}
      >
        {t("Add Photo")}
      </Button>

      <Dialog
        fullWidth
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <ImageManager
          value={value}
          onSelect={(phots) => {
            if (phots && phots.length > 0) {
              _setValue(phots[0]);
              setOpen(false);
            }
          }}
        />
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t("Cancel")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default UploadImage;
